<template>
    <div v-if="messages.length > 0">
        <Carousel
                :autoplayInterval="5000"

                key="updateCarousel"
                :numVisible="3" :numScroll="3"
                :responsiveOptions="responsiveOptions"
                dir="ltr"
                :value="messages">
<!--            <template #header>-->
<!--                <h5>Basic</h5>-->
<!--            </template>-->
            <template #item="slotProps">
                <div class="product-item">
                <Message :closable="false" @close="close($event, slotProps.data.id)" dir="rtl" class="p-m-3" :severity="slotProps.data.type" :key="slotProps.data.id">
                     <div
                             style="
                              display: block;/* or inline-block */
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: auto;
  max-height: 4.6em;
  line-height: 1.8em;
/*                             overflow: scroll;*/
/*text-overflow: ellipsis;*/
/*display: -webkit-box;*/
/*-webkit-line-clamp: 2;*/
/*        line-clamp: 2;*/
/*-webkit-box-orient: vertical;*/
"
                     >
                         {{slotProps.data.content}}

                     </div>
<!--                    <textarea style="-->
<!--                    max-height: 50px;-->
<!--                    overflow: scroll;-->

<!--   /*text-overflow: ellipsis;*/-->
<!--   /*display: -webkit-box;*/-->
<!--   /*-webkit-line-clamp: 2; !* number of lines to show *!*/-->
<!--   /*        line-clamp: 2;*/-->
<!--   /*-webkit-box-orient: vertical;*/-->
<!--">-->

<!--                    {{slotProps.data.content}}-->
<!--                    </textarea>-->
                </Message>
                </div>
            </template>
        </Carousel>
<!--        <Carousel :value="messages"  >-->
<!--        -->
<!--        </Carousel>-->

    </div>

</template>

<script>
import Service from "../../service/Service";

export default {
    service: null,
    name: "SystemMessagesDisplay",
    async created() {
        this.service = new Service();
        const messages = await this.getMessages()
        messages.sort((a,b) =>this.compareMessages(a,b))
        this.messages = messages
    },
    methods: {
        compareMessages(a,b){
            if (a.sort > b.sort){
                return a
            } else if (b.sort > a.sort){
                return b
            } else return 0
        },
        async getMessages() {
           return  this.service.getRelevantSystemMessages()
        }
    },
    data() {
        return {
            updateCarousel:0,
            responsiveOptions: [
                {
                    breakpoint: '1024px',
                    numVisible: 3,
                    numScroll: 3
                },
                {
                    breakpoint: '900px',
                    numVisible: 2,
                    numScroll: 2
                },
                {
                    breakpoint: '480px',
                    numVisible: 1,
                    numScroll: 1
                }
            ],
            messages: null
        }
    },
}
</script>

<style scoped>
/*.product-item {*/
/*    border: 1px solid var(--surface-border);*/
/*    border-radius: 3px;*/
/*    margin: .3rem;*/
/*    text-align: center;*/
/*    padding: 2rem 0;*/
/*}*/

>>>.p-message .p-message-icon {
    margin-right: 0.0rem;
}
>>>.p-message-close.p-link {
    margin-right: auto;
}

>>>.p-message-close.p-link {
     margin-left: 0;
    /*overflow: hidden;*/
    /*position: relative;*/
}
>>>.p-message .p-message-text {
    margin-right: 10px;
}
</style>